/* eslint-disable no-unused-vars */

export enum WebviewPlatform {
  ANDROID = 'android',
  IOS = 'ios'
}

export const WEBVIEW_QUERY_KEY = 'is_mobile'
